const HEADING_TAG_PATTERN = /^H[1-6]$/;
const LEADING_WRAPPER_TAGS = new Set(['ARTICLE', 'DIV', 'HEADER', 'MAIN', 'SECTION', 'SPAN']);
const MEANINGFUL_ELEMENT_SELECTOR = [
  'audio',
  'button',
  'form',
  'hr',
  'iframe',
  'img',
  'input',
  'ol',
  'picture',
  'svg',
  'table',
  'ul',
  'video'
].join(',');

const normalizeHeadingText = (value = '') => String(value)
  .normalize('NFKC')
  .replace(/\u00a0/g, ' ')
  .replace(/\s+/g, ' ')
  .trim()
  .toLocaleLowerCase('en-US');

const isVisuallyEmpty = (element) => (
  normalizeHeadingText(element.textContent) === ''
  && !element.querySelector(MEANINGFUL_ELEMENT_SELECTOR)
);

const findLeadingHeading = (parent) => {
  for (const node of parent.childNodes) {
    if (node.nodeType === Node.COMMENT_NODE) {
      continue;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      if (normalizeHeadingText(node.textContent) !== '') {
        return null;
      }
      continue;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      continue;
    }

    if (HEADING_TAG_PATTERN.test(node.tagName)) {
      return node;
    }

    if (LEADING_WRAPPER_TAGS.has(node.tagName)) {
      const nestedHeading = findLeadingHeading(node);
      if (nestedHeading) {
        return nestedHeading;
      }
    }

    if (isVisuallyEmpty(node)) {
      continue;
    }

    return null;
  }

  return null;
};

/**
 * Removes only a leading CMS heading that repeats the page-shell title.
 * The HTML must already be sanitized before it is passed to this helper.
 */
export const removeLeadingDuplicateHeading = (sanitizedHtml, pageTitle) => {
  if (!sanitizedHtml || !pageTitle || typeof document === 'undefined') {
    return sanitizedHtml || '';
  }

  const root = document.createElement('div');
  root.innerHTML = sanitizedHtml;

  const heading = findLeadingHeading(root);
  if (!heading || normalizeHeadingText(heading.textContent) !== normalizeHeadingText(pageTitle)) {
    return sanitizedHtml;
  }

  let parent = heading.parentElement;
  heading.remove();

  while (parent && parent !== root && isVisuallyEmpty(parent)) {
    const nextParent = parent.parentElement;
    parent.remove();
    parent = nextParent;
  }

  return root.innerHTML;
};
